"use client";

import { useEffect, useState } from "react";
import styles from "../../(general-header)/winners/winners.module.css";
import "react-loading-skeleton/dist/skeleton.css";
import { useAppDispatch } from "../../redux/hooks";
import { getPrizeCollectionWinners } from "./prize-collection.service";
import { YearFilters } from "../../(general-header)/winners/types";
import { MAX_YEARS } from "../../(general-header)/winners/winners-constants";
import Loader from "../../(general-header)/winners/loader";
import WinnersFilters from "../../(general-header)/winners/winners-filters";
import NoWinners from "../../(general-header)/winners/noWinners";
import WinnersTimeline from "../../(general-header)/winners/winners-timeline";
import { publishedFilteredPrizeCollectionWinners } from "../../redux/features/winners/winnersSlice";
import { PrizeCollectionWinnersProps } from "./types";
import { CurrentPageContext } from "../../(general-header)/winners/winners-context";

const PrizeCollection = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [winners, setWinners] = useState<PrizeCollectionWinnersProps>();

  useEffect(() => {
    getPrizeCollectionWinnerList();
  }, []);

  const getPrizeCollectionWinnerList = async () => {
    try {
      const response = await getPrizeCollectionWinners();
      const { data: winnersData } = (await response.json()) as PrizeCollectionWinnersProps;
      setWinners({ data: winnersData });
      dispatch(
        publishedFilteredPrizeCollectionWinners({
          winners: winnersData.prizeCollectionWinners,
        })
      );
    } catch (err) {
      console.log(`Error while fetching the winners data - ${JSON.stringify(err)}`);
    }
    setIsLoading(false);
  };

  const getYearFilters = (): YearFilters => {
    let yearsArchive: number[] = [];
    let years: number[] = [];
    const yearList = [
      ...new Set(winners?.data?.prizeCollectionWinners.map(winner => parseInt(winner.PickupDate.Year))),
    ];
    yearList.sort((a, b) => b - a);
    yearsArchive = yearList?.length > MAX_YEARS ? yearList.slice(MAX_YEARS, yearList.length) : [];
    years = yearsArchive.length > 0 ? yearList.slice(0, yearList.length - yearsArchive.length) : yearList;
    return { yearsArchive, years };
  };

  const parseInfoText = (infoText: string): string =>
    infoText?.replace("<br />", "").replace("<p>", "").replace("</p>", "");

  return isLoading ? (
    <Loader />
  ) : (
    <CurrentPageContext.Provider value={false}>
      <section className="container mx-auto mt-5 mainSection prize-collection-winners">
        <h1 data-testid="winners-title" className={styles.winnersTitle}>
          {winners?.data?.title}
        </h1>
        <p className="text-center mb-4 px-10">{parseInfoText(winners?.data?.infoText)}</p>
        <WinnersFilters filters={getYearFilters()} prizeCollectionWinners={winners?.data?.prizeCollectionWinners} />
        {!winners?.data?.prizeCollectionWinners ||
        !Array.isArray(winners?.data?.prizeCollectionWinners) ||
        winners?.data?.prizeCollectionWinners.length === 0 ? (
          <NoWinners />
        ) : (
          <WinnersTimeline />
        )}
      </section>
    </CurrentPageContext.Provider>
  );
};

export default PrizeCollection;
